import { render } from "./NewArrivals.vue?vue&type=template&id=3e8c4e0a&scoped=true"
import script from "./NewArrivals.vue?vue&type=script&lang=js"
export * from "./NewArrivals.vue?vue&type=script&lang=js"

import "./NewArrivals.vue?vue&type=style&index=0&id=3e8c4e0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8c4e0a"]])

export default __exports__